<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import NoResult from '../../../components/common/NoResult'
    import '@/common/js/common-plugins';
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        toolbox: {
            feature: {
                // magicType: {show: true, type: ['line', 'bar']},
                // restore: {show: true},
                saveAsImage: {show: true,pixelRatio:2,name:'各机构走势图TOP10-交易笔数' +   new Date().format('yyyyMMddHHmmss')}
            },
            right:20
        },
        legend: {
            data:['快捷收款','完美还款','极速还款','交易笔数']
        },
        xAxis: [
            {
                type: 'category',
                // data: ['信创圈','信创圈2','信创圈3','信创圈4','信创圈5','信创圈6','信创圈7','信创圈8','信创圈9','信创圈10'],
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [{
            type: 'value',
            name: '单位：笔',
        }],
        // series: [],
        color:['#079ADE','#FF6867','#FFAE2E','#546570']
    };


    export default {
        name: "TopNumChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,

            };
        },
        props:{
            params:{
                type:Object,
                default:() => {},
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch:{
            params(newVal,oldVal){
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params){
                if(params.nameList.length == 0){
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {
                console.log(data);
                this.charts.setOption({
                    series: [
                        {
                            name:'快捷收款',
                            type:'bar',
                            data:data.quickList
                        },
                        {
                            name:'完美还款',
                            type:'bar',
                            data:data.perfList
                        },
                        {
                            name:'极速还款',
                            type:'bar',
                            data:data.fastList
                        },
                        {
                            name:'交易笔数',
                            type:'bar',
                            data:data.succTran
                        }
                    ],
                    xAxis:  {
                        data: data.nameList
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap{
        width: 100%;
        height: 500px;
    }
    .chart{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/TopNumChart.vue